import { Pipe, PipeTransform } from '@angular/core';

import * as CryptoJS from 'crypto-js';
import {
  encryptKey,
  equalEncryptKey,
  plusEncryptKey,
  slashEncryptKey,
} from '../constants';
import * as moment from 'moment-timezone';

@Pipe({ name: 'CelisusToFarenhietFormat' })
export class CelisusToFarenhietFormatPipe implements PipeTransform {
  transform(val: any) {
    let calVal: any = val * (9 / 5) + 32;

    return parseFloat(calVal).toFixed(2);
  }
}

@Pipe({ name: 'FarenhietToCelisusFormat' })
export class FarenhietToCelisusFormatPipe implements PipeTransform {
  transform(val: any) {
    let calVal: any = ((val - 32) * 5) / 9;
    return parseFloat(calVal).toFixed(2);
  }
}

@Pipe({ name: 'ReplaceTrimster' })
export class ReplaceTrimsterFormatPipe implements PipeTransform {
  transform(val: any, matchVal: any) {
    return val.replace(matchVal, '');
  }
}

@Pipe({ name: 'ExtensionFormat' })
export class ExtensionFormatPipe implements PipeTransform {
  transform(val: any) {
    let calVal: any = /[^.]+$/.exec(val);

    return calVal;
  }
}

@Pipe({ name: 'EncryptFormat' })
export class EncryptFormatPipe implements PipeTransform {
  transform(val: any) {
    let calVal: any = CryptoJS.AES.encrypt('"' + val + '"', encryptKey)
      .toString()
      .replace(/\+/g, plusEncryptKey)
      .replace(/\//g, slashEncryptKey)
      .replace(/=/g, equalEncryptKey);

    return calVal;
  }
}

@Pipe({ name: 'DecryptFormat' })
export class DecryptFormatPipe implements PipeTransform {
  transform(val: any) {
    let calVal: any = val
      .replace(new RegExp(plusEncryptKey, 'g'), '+')
      .replace(new RegExp(slashEncryptKey, 'g'), '/')
      .replace(new RegExp(equalEncryptKey, 'g'), '=');

    calVal = CryptoJS.AES.decrypt(calVal, encryptKey).toString(
      CryptoJS.enc.Utf8
    );

    return calVal;
  }
}

@Pipe({ name: 'CheckTimeGreaterFormat' })
export class CheckTimeGreaterFormatPipe implements PipeTransform {
  transform(from_time: any, c_date: Date) {
    var now = new Date();

    let const_date = moment(c_date).format('YYYY-MM-DD');
    let const_datetime = moment(const_date + ' ' + from_time).format(
      'YYYY-MM-DD hh:mm:ss'
    );

    var current_time = moment(now).format('YYYY-MM-DD hh:mm:ss');

    if (const_datetime > current_time) {
      return true;
    } else {
      return false;
    }
  }
}

@Pipe({
  name: 'Age',
})
export class AgeFormatPipe implements PipeTransform {
  transform(value: Date | moment.Moment, args: string[]): any {
    if (!value) return value;

    return moment().diff(value, 'years') + ' Years';
  }
}

@Pipe({
  name: 'StringtoReplace',
})
export class StringtoReplacePipe implements PipeTransform {
  transform(value: string, strToReplace: string, replacementStr: string): any {
    if (!value || !strToReplace || !replacementStr) {
      return value;
    }
    let re = null;
    if (strToReplace == 'underscore') {
      re = /_/g;
    }

    return value.replace(re, replacementStr);
  }
}

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  /*
  The transform method is essential to a pipe. The PipeTransform interface defines that method and guides both tooling and the compiler. Technically, it's optional; Angular looks for and executes the transform method regardless.
  */

  transform(value: string, limit: number): string {
    return value.length < limit ? value : value.slice(0, limit) + '...';
  }
}

@Pipe({ name: 'replace' })
export class ReplacePipe implements PipeTransform {
  transform(
    value: string,
    strToReplace: string,
    replacementStr: string
  ): string {
    if (!value || !strToReplace || !replacementStr) {
      return value;
    }

    return value.replace(
      new RegExp(this.escapeStr(strToReplace), 'g'),
      replacementStr
    );
  }

  escapeStr(str) {
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
}
